<template>
  <div class="loading-mask" v-show="loading">
      <img class="loading" src="@/assets/img/search-w.gif" alt="">
  </div>
</template>

<script>
export default {
  data() {
    return {

    };
  },
  methods: {

  },
  props: {
    loading:{
      default:false,
      type: Boolean,
    }
  }
};
</script>

<style lang="scss" >
.loading-mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index:9999;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(0,0,0,.2);
    > .loading {
      width: 224px;
      // height: 264px;
    }
}

</style>